import RevisableLanguagePack from "../../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../../../core/application/MediatorManager";
import ClickEaterFactory from "../../../../../core/ui/ClickEaterFactory";
import FileExplorerModel from "../../../../files/model/FileExplorerModel";
import FileInteractionEvent from "../../../../files/model/FileInteractionEvent";
import FileModel from "../../../../files/model/FileModel";
import LaptopSkinKeyRegistry from "../../../model/LaptopSkinKeyRegistry";
import AbstractLaptopMediator from "../../AbstractLaptopMediator";

export default class LaptopFileExplorerScreenMediator extends AbstractLaptopMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {FileModel} fileModel 
     * @param {FileExplorerModel} fileExplorerModel 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, fileModel, fileExplorerModel, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._fileModel = fileModel;
        this._fileExplorerModel = fileExplorerModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;

        this._items = [];
    }

    initialize() {
        super.initialize();

        this._target.fileExplorer.customData = {
            skinKeyRegistry: LaptopSkinKeyRegistry
        };
        this._fileExplorerMediator = this._mediatorManager.createMediator(this._target.fileExplorer, LaptopSkinKeyRegistry.FILE_EXPLORER_SKIN);

        this._closeButton = this.createButton(this._target.closeButton, this._handleCloseButton.bind(this));

        this.registerEventListener(FileInteractionEvent.OPEN_FILE, this._handleOpenFile.bind(this));
        this.registerEventListener(FileInteractionEvent.CLOSE_FILE, this._handleCloseFile.bind(this));
    }

    destroy() {
        super.destroy();

        this._fileExplorerMediator.destroy();

        if (this._laptopFileViewerScreenSkin) {
            this.closeScreen(this._laptopFileViewerScreenSkin, null, {
                file: data.file
            });
            this._laptopFileViewerScreenSkin = null;
        }

        // Reset to root directory
        this._fileExplorerModel.currentFileTreeNode = this._fileModel.fileTree.root;
    }

    _handleCloseButton() {
        this.gotoScreen(LaptopSkinKeyRegistry.LAPTOP_MAIN_SCREEN_SKIN);
    }

    _handleOpenFile(evt) {
        const data = evt.params.data;

        this._laptopFileViewerScreenSkin = this.openScreen(LaptopSkinKeyRegistry.LAPTOP_FILE_VIEWER_SCREEN_SKIN, null, {
            file: data.file
        });
    }

    _handleCloseFile(evt) {
        const data = evt.params.data;

        if (this._laptopFileViewerScreenSkin) {
            this.closeScreen(this._laptopFileViewerScreenSkin, null, {
                file: data.file
            });
            this._laptopFileViewerScreenSkin = null;
        }
    }
}